import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const HelpSupport: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={10}>
          {/* Header */}
          <div className="text-center mb-5">
            <h1 className="display-5 fw-bold mb-3">Need Support?</h1>
            <p className="lead text-muted">
              We're here to help you succeed. For help and support, email us at info.nqpay@gmail.com.
            </p>
            <div className="mt-3">
              <strong>Support Email:</strong>{' '}
              <a href="mailto:info.nqpay@gmail.com" className="text-decoration-none">
                info.nqpay@gmail.com
              </a>
            </div>
          </div>

          {/* Contact Options */}
          <Row className="mb-5">
            <Col>
              <h2 className="h4 mb-4">Our Contact Options</h2>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col lg={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="p-4">
                  <div className="text-center mb-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                      <i className="fas fa-envelope text-primary fa-lg"></i>
                    </div>
                  </div>
                  <h5 className="text-center mb-3">Email Support</h5>
                  <p className="text-muted mb-3">
                    <strong>Best for:</strong> Detailed inquiries, technical issues, and non-urgent questions.
                  </p>
                  <div className="mb-3">
                    <strong>Address:</strong>{' '}
                    <a href="mailto:info.nqpay@gmail.com" className="text-decoration-none">
                      info.nqpay@gmail.com
                    </a>
                  </div>
                  <div className="text-muted small">
                    <strong>Response Time:</strong> We aim to respond within 24 business hours.
                  </div>
                  <div className="text-center mt-4">
                    <Button 
                      href="mailto:info.nqpay@gmail.com"
                      variant="outline-primary"
                      className="px-4"
                    >
                      Send Email
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="p-4">
                  <div className="text-center mb-3">
                    <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                      <i className="fas fa-question-circle text-success fa-lg"></i>
                    </div>
                  </div>
                  <h5 className="text-center mb-3">Quick Help</h5>
                  <p className="text-muted mb-3">
                    Find answers to common questions and troubleshooting guides.
                  </p>
                  <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                      <span>Account & Login Issues</span>
                      <i className="fas fa-chevron-right text-muted small"></i>
                    </div>
                    <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                      <span>Task Completion Guide</span>
                      <i className="fas fa-chevron-right text-muted small"></i>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Withdrawal Process</span>
                      <i className="fas fa-chevron-right text-muted small"></i>
                    </div>
                  </div>
                  <div className="text-center">
                    <Button 
                      variant="outline-success"
                      className="px-4"
                      disabled
                    >
                      Coming Soon
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Resources & Guides */}
          <Row className="mb-5">
            <Col>
              <h2 className="h4 mb-4">Resources & Guides</h2>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col md={6} className="mb-4">
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="mb-3">
                    <i className="fas fa-question-circle text-warning me-2"></i>
                    Frequently Asked Questions (FAQ)
                  </h5>
                  <div className="mb-3">
                    <div className="mb-2">
                      <a href="#" className="text-decoration-none d-block py-1">
                        How do I reset my password? <span className="text-muted">[Link]</span>
                      </a>
                    </div>
                    <div className="mb-2">
                      <a href="#" className="text-decoration-none d-block py-1">
                        What is your return policy? <span className="text-muted">[Link]</span>
                      </a>
                    </div>
                    <div className="mb-2">
                      <a href="#" className="text-decoration-none d-block py-1">
                        Can I upgrade my subscription? <span className="text-muted">[Link]</span>
                      </a>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-4">
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="mb-3">
                    <i className="fas fa-video text-danger me-2"></i>
                    Video Tutorials
                  </h5>
                  <p className="text-muted mb-3">
                    Watch step-by-step guides on product setup and feature usage.
                  </p>
                  <Button 
                    variant="outline-danger"
                    className="w-100"
                    disabled
                  >
                    <i className="fab fa-youtube me-2"></i>
                    YouTube Playlist/Video Library <span className="text-muted small">[Coming Soon]</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Important Policies */}
          <Row>
            <Col>
              <h2 className="h4 mb-4">Important Policies</h2>
            </Col>
          </Row>

          <Row>
            <Col md={4} className="mb-3">
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4 text-center">
                  <i className="fas fa-file-contract text-primary fa-2x mb-3"></i>
                  <h6 className="mb-2">Terms of Service</h6>
                  <Button variant="outline-primary" size="sm" disabled>
                    View Terms <span className="text-muted small">[Link]</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-3">
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4 text-center">
                  <i className="fas fa-shield-alt text-success fa-2x mb-3"></i>
                  <h6 className="mb-2">Privacy Policy</h6>
                  <Button variant="outline-success" size="sm" disabled>
                    View Policy <span className="text-muted small">[Link]</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-3">
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4 text-center">
                  <i className="fas fa-undo text-warning fa-2x mb-3"></i>
                  <h6 className="mb-2">Refund & Return Policy</h6>
                  <Button variant="outline-warning" size="sm" disabled>
                    View Policy <span className="text-muted small">[Link]</span>
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Contact CTA */}
          <Row className="mt-5">
            <Col>
              <Card className="bg-primary text-white border-0">
                <Card.Body className="p-4 text-center">
                  <h4 className="mb-3">Still Need Help?</h4>
                  <p className="mb-4">
                    Can't find what you're looking for? Our support team is ready to assist you with any questions or concerns.
                  </p>
                  <Button 
                    href="mailto:info.nqpay@gmail.com"
                    variant="light"
                    size="lg"
                    className="px-4"
                  >
                    <i className="fas fa-envelope me-2"></i>
                    Contact Support
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default HelpSupport;